<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1300"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <nz-table appColumnLayout
      nzShowSizeChanger
      [nzData]="vouchers"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      id="voucher-code-details-table"
      >
      <thead>
        <tr>
          <th nzColumnKey="id" nzWidth="75px">#ID</th>
          <th nzColumnKey="seriesName">Name der Serie</th>
          <th nzColumnKey="orderNumber">Bestellnummer</th>
          <th nzColumnKey="type">Typ</th>
          <th nzColumnKey="amount">Betrag</th>
          @if (voucherSeriesTypes[voucher?.voucherSeries.type] !== voucherSeriesTypes.P) {
            <th nzColumnKey="remainingAmount">Verbleibender Betrag</th>
          }
          <th nzColumnKey="code">Code</th>
          <th nzColumnKey="status">Status</th>
          @if (voucherSeriesTypes[voucher?.voucherSeries.type] !== voucherSeriesTypes.P) {
            <th nzColumnKey="soldAt">Verkaufsdatum</th>
          }
          <th nzColumnKey="actions"></th>
        </tr>
      </thead>
      <tbody>
        @for (voucher of vouchers; track voucher) {
          <tr>
            <td>{{ voucher.id }}</td>
            <td>{{ voucher.voucherSeries.description }}</td>
            <td>{{ voucher.orderNumber }}</td>
            <td>{{ voucherSeriesTypes[voucher.voucherSeries.type] }}</td>
            <td>{{ voucherSeriesTypes[voucher.voucherSeries.type] === voucherSeriesTypes.P ? (voucher.amount + '%') : (voucher.amount | currency) }}</td>
            @if (voucherSeriesTypes[voucher.voucherSeries.type] !== voucherSeriesTypes.P) {
              <td>{{ voucher.remainingAmount | currency }}</td>
            }
            <td class="white-space-no-wrap">{{ voucher.code }}</td>
            <td>{{ voucherCodeStatuses[voucher.status] }}</td>
            @if (voucherSeriesTypes[voucher.voucherSeries.type] !== voucherSeriesTypes.P) {
              <td
                class="white-space-no-wrap"
                >
                {{ voucher.saleDate ? (voucher.saleDate | dateFormat) : 'Nicht verkauft' }}
              </td>
            }
            <td>
              <div class="d-flex align-items-center">
                <i
                  nz-icon
                  nzType="history"
                  style="margin-right: 8px; cursor: pointer;"
                  (click)="voucherHistoryModalComponent.showModal({ id: voucher.id, isPercentage: voucherSeriesTypes[voucher.voucherSeries.type] === voucherSeriesTypes.P })"
                  nz-tooltip
                  nzTooltipTitle="Gutscheinverlauf öffnen"
                ></i>
                @if (voucher.documentKey && voucherSeriesTypes[voucher.voucherSeries.type] !== voucherSeriesTypes.P) {
                  <app-download-document
                    [documentKey]="voucher.documentKey"
                  ></app-download-document>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    @if (voucher && voucherSeriesTypes[voucher.voucherSeries.type] !== voucherSeriesTypes.P) {
      <div
        class="d-flex justify-content-center buttons-row"
        >
        @if (!voucher.saleDate && voucherSeriesTypes[voucher.voucherSeries.type] !== voucherSeriesTypes.G) {
          <button
            nz-button
            nzType="primary"
            (click)="setVoucherAsSold()"
            [nzLoading]="isLoading"
            [disabled]="isLoading"
            >
            Gutschein als verkauft einstellen
          </button>
        }
        @if (voucherCodeStatuses[voucher.status] !== voucherCodeStatuses.Redeemed) {
          <button
            nz-button
            nzType="default"
            (click)="setVoucherAsRedeemed()"
            [nzLoading]="isLoading"
            [disabled]="isLoading"
            >
            Gutschein als eingelöst kennzeichnen
          </button>
        }
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
  </ng-template>
</nz-modal>

<app-voucher-history-modal #voucherHistoryModalComponent></app-voucher-history-modal>
